import React from 'react'
import styled from 'styled-components'
import { useAtom } from 'jotai'
import ActiveFilterChip from '@/components/activeFilterChip/ActiveFilterChip'
import {
    selectedFilterAreaAtom,
    selectedFilterBatteryStatusAtom,
    selectedFilterDeviceAtom,
    selectedFilterProjectAtom,
    selectedFilterProtocolAtom,
    selectedFilterSensorTypeAtom,
    selectedFilterSignalQualityAtom,
    selectedFilterStatusAtom,
    selectedFilterSuperiorTagAtom,
    selectedFilterSystemAtom,
} from '@/core/store/globalStore'
import { buildDashboardFilterChips, DashboardFilterChipModel } from './dashboardFilterChips'

const ChipRow: React.FC = () => {
    const [selectedStatuses, setSelectedStatuses] = useAtom(selectedFilterStatusAtom)
    const [selectedDevice, setSelectedDevice] = useAtom(selectedFilterDeviceAtom)
    const [selectedSensorType, setSelectedSensorType] = useAtom(selectedFilterSensorTypeAtom)
    const [selectedProtocol, setSelectedProtocol] = useAtom(selectedFilterProtocolAtom)
    const [selectedProject, setSelectedProject] = useAtom(selectedFilterProjectAtom)
    const [selectedSuperiorTag, setSelectedSuperiorTag] = useAtom(selectedFilterSuperiorTagAtom)
    const [selectedSystem, setSelectedSystem] = useAtom(selectedFilterSystemAtom)
    const [selectedArea, setSelectedArea] = useAtom(selectedFilterAreaAtom)
    const [selectedBatteryStatus, setSelectedBatteryStatus] = useAtom(selectedFilterBatteryStatusAtom)
    const [selectedSignalQuality, setSelectedSignalQuality] = useAtom(selectedFilterSignalQualityAtom)

    const chips = buildDashboardFilterChips({
        statuses: selectedStatuses,
        device: selectedDevice,
        sensorType: selectedSensorType,
        protocol: selectedProtocol,
        project: selectedProject,
        superiorTag: selectedSuperiorTag,
        system: selectedSystem,
        area: selectedArea,
        batteryStatus: selectedBatteryStatus,
        signalQuality: selectedSignalQuality,
    })

    const removeChip = (chip: DashboardFilterChipModel) => {
        switch (chip.filter) {
            case 'status':
                setSelectedStatuses(selectedStatuses.filter((current) => current.value !== chip.statusValue))
                break
            case 'device':
                setSelectedDevice(null)
                break
            case 'sensorType':
                setSelectedSensorType(null)
                break
            case 'protocol':
                setSelectedProtocol('')
                break
            case 'project':
                setSelectedProject(null)
                break
            case 'superiorTag':
                setSelectedSuperiorTag(null)
                break
            case 'system':
                setSelectedSystem(null)
                break
            case 'area':
                setSelectedArea(null)
                break
            case 'batteryStatus':
                setSelectedBatteryStatus(null)
                break
            case 'signalQuality':
                setSelectedSignalQuality(null)
                break
        }
    }

    return (
        <Row>
            {chips.map((chip) => (
                <ActiveFilterChip key={chip.key} onDelete={() => removeChip(chip)}>
                    {chip.label}
                </ActiveFilterChip>
            ))}
        </Row>
    )
}

const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 16px;
    justify-content: flex-start;
    gap: 8px;

    &:empty {
        margin-top: 0;
    }
`

export default ChipRow
